import React from 'react'
import NavBar from '../Components/NavBar'
import List from '../Components/List'
import Footer from '../Components/Footer'
import './layout.css'
import './About.css'
import img_about from '../img/about.png'
import img_me from '../img/about_me.png'

class Aboutme extends React.Component{
    render(){
        return(
            
            <div id="about-top" className="content-section">

                <div id="me">
                    <img src={img_me} />
                </div>

                <div id="intro">
                    
                    Hello! My name is Vivian! <br/>
                    I am a third-year PhD student in the EECS Department at UC Berkeley, in the 
                    <a href="https://www.hybrid-ecologies.org/" target="_blank">Hybrid Ecologies Lab</a>, 
                    advised by <a href="http://www.paulos.net/" target="_blank">Prof. Eric Paulos</a>.
                    <br/>
                    I hold a joint Master’s degree in Design Engineering from Brown University and 
                    Rhode Island School of Design (RISD). Previously, I was a visiting research student at the 
                    <a href="https://hcie.csail.mit.edu/" target="_blank">MIT HCI Engineering Group</a>, 
                    advised by <a href="https://hcie.csail.mit.edu/stefanie-mueller.html" target="_blank">Prof. Stefanie Mueller</a> 
                    and <a href="https://www.megan-hofmann.com/" target="_blank">Visiting Prof. Megan Hofmann</a>, 
                    and an undergraduate HCI researcher at the National Taiwan University HCI Lab, 
                    advised by <a href="http://www.lungpancheng.tw/" target="_blank">Prof. Lung-Pan Cheng</a>.
                    <br/><br/>
                    I am deeply inspired by, and constantly in awe of, how nature makes things and solves problems.
                    <br/>
                    In my free time, I enjoy drawing and watching animal documentaries.

                    <br/>

                    <br/>

                    <div id="contacts">
                        <a href="mailto:vhchan@berkeley.edu" target='_blank'>vhchan@berkeley.edu</a>
                        <a href="https://twitter.com/vvhchan" target='_blank'>twitter</a>
                    </div>
                    

                </div>

            </div>
        )
    }
}

export default Aboutme